const UUID = '[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}'

export const ASSET_REFERENCE_PATTERN = new RegExp(`^asset:\\/\\/(${UUID})(?:@(${UUID}))?$`)

export type ParsedAssetReference = {
  entityId: string
  versionId?: string
}

export const parseAssetReference = (value: string): ParsedAssetReference | null => {
  const match = value.trim().match(ASSET_REFERENCE_PATTERN)
  if (!match) return null
  const entityId = match[1].toLowerCase()
  const versionId = match[2]?.toLowerCase()
  return versionId ? { entityId, versionId } : { entityId }
}

export const normalizeAssetReference = (value: string): string => {
  const ref = parseAssetReference(value)
  if (!ref) throw new Error(`Asset reference "${value}" must use the form asset://<uuid> or asset://<uuid>@<uuid>.`)
  return ref.versionId ? `asset://${ref.entityId}@${ref.versionId}` : `asset://${ref.entityId}`
}
